export default __webpack_public_path__ + "static/media/openEye.9afdd13a.svg";